<template>
	<div>
		<BaseAccordionCard
			:accordion_header="getStateWithParam('tiranaECS_label')"
			:toggable="false"
		>
			<template v-slot:component>
				<div class="contact-info-middle">
					<v-img
						:src="require('@/assets/img/tiranaeyc-banner.jpg')"
						aspect-ratio="2"
					></v-img>
					<div
						style="margin-top: 15px"
						class="contact-info-info contact-info-middle-bottom"
					>
						<p>{{ getStateWithParam("tiranaeyc_long_desc") }}</p>
					</div>
					<div class="contact-info-info contact-info-middle-bottom">
						<div
							class="contact-info-icon-label"
							@click="
								openEmbedBrowser('https://tiranaeyc2022.al')
							"
						>
							<i class="material-icons">language</i>
							<span class="contact-info-middle-hour"
								>Website</span
							>
						</div>
						<div
							class="contact-info-right contact-info-adres"
							@click="
								openEmbedBrowser('https://tiranaeyc2022.al')
							"
						>
							tiranaeyc2022.al
						</div>
					</div>
					<!-- <div class="contact-info-info contact-info-middle-bottom mt-3">
					<div class="contact-info-icon-label" @click="openEmbedBrowser('https://tiranaeyc2022.al/kalendari/')">
						<i class="material-icons">event</i>
						<span class="contact-info-middle-hour">Calendar</span>
					</div>
					<div
					class="contact-info-right contact-info-adres"
					@click="openEmbedBrowser('https://tiranaeyc2022.al/kalendari/')"
					>tiranaeyc2022.al/kalendari/</div>
      			</div> -->
				</div>
			</template>
		</BaseAccordionCard>
		<BaseAccordionCard
			:accordion_header="getStateWithParam('tirana_eyc_calendar')"
			:toggable="false"
		>
			<template v-slot:icon>
				<i
					class="material-icons primary--text"
					style="flex: inherit; margin-right: 10px"
					>event</i
				>
			</template>
			<template v-slot:component>
				<div
					id="eyc-events-container"
					class="eyc-events-container"
					v-html="events"
				></div>
			</template>
		</BaseAccordionCard>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
import { TIRANA_EYC_EVENTS } from "@/config/api/url/urls_in_app";
import { API_CLIENT } from "@/config/api/api_call/service_instances";
export default {
	name: "TiranaEYCContent",
	data() {
		return {
			events: "",
		};
	},
	created() {
		this.getEvents();
	},
	mounted() {
		let $this = this;
		this.$nextTick(function () {
			this.$store.state.active_loader = false;
		});
		this.$el.querySelector("#eyc-events-container").addEventListener(
			"click",
			function (event) {
				//console.log(event.preventDefault())
				event.preventDefault();
				let eventitem = event.composedPath().find((el) => {
					return el.nodeName === "ARTICLE";
				});
				if (eventitem) {
					let eventurl = eventitem
						.querySelector("a")
						.getAttribute("data-href");
					//console.log(eventurl);
					$this.openEmbedBrowser(eventurl);
				}
			},
			{ capture: true }
		);
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		openEmbedBrowser(url) {
			native_capacitor.openUrl(url);
		},
		getEvents() {
			API_CLIENT(TIRANA_EYC_EVENTS)
				.then((response) => {
					if (response.content_html) {
						let eventsdom = $(response.content_html).find(
							".mec-month-side"
						);
						let currentmonth = new Date().getMonth() + 1;
						eventsdom.children().each(function (itemind, item) {
							//console.log(item.querySelectorAll('a'))
							item.querySelectorAll("a").forEach((link) => {
								if (link.getAttribute("href")) {
									link.setAttribute(
										"data-href",
										link.getAttribute("href")
									);
									link.removeAttribute("href");
								}
							});
							let dateattr = item.getAttribute("data-mec-cell");
							dateattr = Number(dateattr.substring(4, 6));
							if (dateattr < currentmonth) {
								item.remove();
							}
						});
						this.events = eventsdom.html();
					}
					this.$store.state.active_loader = false;
				})
				.catch((err) => {
					this.$store.state.active_loader = false;
				});
		},
	},
};
</script>

<style scoped lang="scss">
.contact-info-middle {
	display: flex;
	flex-direction: column;
	padding: 0 15px 15px 15px;
	font-size: 12px;
	font-weight: 500;
	.contact-info-info {
		display: flex;
		align-items: center;
		&:first-child {
			padding-bottom: 10px;
		}
		.contact-info-icon-label {
			display: flex;
			align-items: center;
			.material-icons {
				font-size: 20px !important;
				color: #e50000;
				padding-right: 5px;
			}
		}
		.contact-info-right {
			margin-left: auto;
		}
		.contact-info-adres {
			color: #0000a2;
		}
		.contact-info-nr {
			color: #007004;
		}
	}
}
.contact-info-bottom {
	font-size: 10px;
	font-weight: 300;
	font-style: italic;
	text-align: center;
	padding-top: 15px;
}
</style>
